/** @format */

import { History } from "history";
import { routerMiddleware } from "connected-react-router";
import { middlwareSaga } from "./middlewareSaga";

export const createMiddlewares = (history: History) => [middlwareSaga, routerMiddleware(history)];
